import styled from 'styled-components'
import { brandSecondaryDarker, grayDarker } from 'utils/style-utils'

export const Box = styled.div`
  background: linear-gradient(to bottom, ${brandSecondaryDarker} 2rem, ${grayDarker} 20rem);
`
